import {IDepotInfo, IDepotSummary, IDepotSummaryMap} from '../Types/IDepot';
import {IResultsData, IResultSummary} from '../Types/IResultsData';
import {IBaseSearchParam} from '../Types/ISearchParam';
import {IPlace} from '../Types/IPlace';

export const removeDuplicates = (data: IResultsData[]): IResultsData[] => {
    const mappedData = {};
    const results: IResultsData[] = [];

    data.forEach((result) => {
        const key = getResultMapKey(result);
        if (typeof mappedData[key] === 'undefined') {
            mappedData[key] = true;
            results.push(result);
        }
    });

    return results;
}

const getResultMapKey = (data: IResultsData): string => {
    // sipp_code, supplier_code, depot_code, price, duration
    return `${data.sipp_code}_${data.supplier_code}_${data.depot_code}_${data.per_day_price}_${data.duration}`;
}

export const processDepotSummaryMap = (depots: IDepotSummaryMap, data: IResultsData): void => {
    const depotMapKey: string = `${data.depot_code}_${data.supplier_code}`;
    let highestPerDay: IResultsData | null = typeof depots[depotMapKey] !== 'undefined' ?  depots[depotMapKey].highestPerDay : null;
    let lowestPerDay: IResultsData | null = typeof depots[depotMapKey] !== 'undefined' ?  depots[depotMapKey].lowestPerDay : null;
    if (!depots.hasOwnProperty(depotMapKey)) {
        depots[depotMapKey] = {
            depot_code: data.depot_code,
            distance: data.distance,
            supplier_code: data.supplier_code,
            supplier_name: data.supplier_name,
            highestPerDay: data,
            lowestPerDay: data,
            address: data.depot_address,
            depot_coordinates: {
                x: data.depot_coordinates.x,
                y: data.depot_coordinates.y
            }
        }
    } else if (
        highestPerDay !== null &&
        highestPerDay.per_day_price < data.per_day_price
    ) {
        depots[depotMapKey].highestPerDay = data;
    } else if (
        lowestPerDay !== null &&
        data.per_day_price < lowestPerDay.per_day_price
    ) {
        depots[depotMapKey].lowestPerDay = data;
    }
}

export const sortDepotSummaryByDistance = (depots: IDepotSummaryMap): IDepotSummary[] => {
    return Object.keys(depots)
        .map((keys) => depots[keys])
        .sort((a, b) => {
            if (a.distance > b.distance) {
                return 1;
            } else if (b.distance > a.distance) {
                return -1;
            }

            return 0;
        });
}

export const processSummary = (summary: IResultSummary, data: IResultsData): void => {
    if (
        summary.models.hasOwnProperty(data.vehicle_data.name) &&
        summary.models[data.vehicle_data.name].lowest.per_day_price > data.per_day_price
    ) {
        summary.models[data.vehicle_data.name].total += 1;
        summary.models[data.vehicle_data.name].lowest = data;
    } else if (
        summary.models.hasOwnProperty(data.vehicle_data.name) &&
        summary.models[data.vehicle_data.name].highest.per_day_price < data.per_day_price
    ) {
        summary.models[data.vehicle_data.name].total += 1;
        summary.models[data.vehicle_data.name].highest = data;
    }
    else if (
        summary.models.hasOwnProperty(data.vehicle_data.name) === false
    ) {
        summary.models[data.vehicle_data.name] = {
            total: 1,
            highest: data,
            lowest: data
        };
    }

    if (summary.types.hasOwnProperty(data.vehicle_data.type)) {
        summary.types[data.vehicle_data.type] += 1;
    } else {
        summary.types[data.vehicle_data.type] = 1;
    }

    if (summary.depots.hasOwnProperty(data.depot_code)) {
        summary.depots[data.depot_code] += 1;
    } else {
        summary.depots[data.depot_code] = 1;
    }
}

export const generatePlaceObject = (searchParams: IBaseSearchParam | null): IPlace | null => {
    if (searchParams === null) {
        return null;
    }

    return {
        name:searchParams.location,
        latitude: searchParams.latitude,
        longitude: searchParams.longitude,
        id: btoa(searchParams.location),
        isAirport: false
    }
}

export const removeDepotInfoDuplicate = (data: IDepotInfo[]): IDepotInfo[] => {
    const mappedData = {};

    data.forEach((depot) => {
       if (typeof mappedData[`${depot.code}_${depot.supplier_code}`] === 'undefined') {
           mappedData[`${depot.code}_${depot.supplier_code}`] = depot;
       }
    });

    return Object
        .keys(mappedData)
        .map((key: string) => mappedData[key]);
}
